module.exports = __webpack_public_path__ + "static/media/bg-titan.9c613f35.png";